/* ------------------------------ Dependencies ------------------------------ */
import { defineStore } from 'pinia'
import { stringify, parse } from 'zipson'
import _ from 'lodash'
/* ----------------------------- Custom Modules ----------------------------- */
import { IPortalUser, ILoginData, IRole, IStaff } from 'src/common/interfaces'
/* -------------------------------------------------------------------------- */

type PortalUserStaff = IPortalUser & IStaff

const defaultPortalUser = {} as PortalUserStaff
const defaultLoginData = {} as ILoginData
const defaultRole = {} as IRole

interface IState {
  token: string
  portalUser: PortalUserStaff
  loginData: ILoginData
  role: IRole
}

export const useAuthStore = defineStore('auth', {
  state: (): IState => ({
    token: '',
    portalUser: defaultPortalUser,
    loginData: defaultLoginData,
    role: defaultRole,
  }),
  getters: {
    hasToken(): boolean {
      return Boolean(this.token?.length)
    },
    hasPortalUser(): boolean {
      return Boolean(Object.keys(this.portalUser).length)
    },
  },
  actions: {
    setToken(tokenString: string): void {
      this.token = tokenString
    },
    removeToken(): void {
      this.token = ''
    },

    setPortalUser(portalUser: Partial<IStaff | IPortalUser>): void {
      _.assign(this.portalUser, portalUser)
    },
    addStoreToPortalUserStoreIds(store_id: number): void {
      this.portalUser.store_ids.push(store_id)
    },
    removePortalUser(): void {
      this.portalUser = defaultPortalUser
    },

    setLoginData(loginData: ILoginData): void {
      this.loginData = loginData
    },
    removeLoginData(): void {
      this.loginData = defaultLoginData
    },

    setRole(role: IRole) {
      this.role = role
    },
  },
  persist: {
    key: 'auth',
    // paths: ["token", "portalUser"],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },
})
